/*
 * Copyright (c) Nexign, JSC, 2020-2023.
 */
/**
 * Initial wizard translations
 *
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @author Yakov Gushchin
 * @author Julia Ignatieva
 * @author Evgeniy Naumov
 * @author Nikolay Sviridov
 * @version 1.32.0
 * @since 1.2.0
 */

import { EWizardName } from '../../../wizard/wizardConstants';
import { IWizardPropsTranslation, IWizardTranslation } from '../../types/wizards/wizard';

export const initWizardTranslation: IWizardTranslation = {
    controls: {
        cancel: '',
        finish: '',
        next: '',
        prev: '',
    },
    wizardModalError: {
        default: '',
        timeout: '',
    },
    wizardModalSummary: {
        details: '',
        megapowers: '',
        orderMessageEnd: '',
        orderMessageStart: '',
        orderName: {
            [EWizardName.ADDITIONAL_ACCOUNTS]: '',
            [EWizardName.ADDITIONAL_REPORTS]: '',
            [EWizardName.BILLS_DOC]: '',
            [EWizardName.CALLS_DETAIL]: '',
            [EWizardName.CHANGE_LOCK]: '',
            [EWizardName.EXPENSES_DETAIL]: '',
            [EWizardName.IMPORT_PERSONAL_DATA]: '',
            [EWizardName.IMPORT_SUBSCRIBERS_LIMITS]: '',
            [EWizardName.LABELS_IMPORT]: '',
            [EWizardName.MONEY_TRANSFER]: '',
            [EWizardName.MULTI_SEARCH]: '',
            [EWizardName.ORDER_TEMPLATE]: '',
            [EWizardName.ORDER_REPORT]: '',
            [EWizardName.PRODUCT_OFFERINGS]: '',
            [EWizardName.PRODUCT_OFFERINGS_CAMPAIGN]: '',
            [EWizardName.COLLATION_REPORT]: '',
            [EWizardName.CHANGE_ROLE]: '',
        },
        showLess: '',
        showMore: '',
        title: '',
    },
    wizardReport: {
        email: '',
        header: '',
        phone: '',
        toSubscribers: '',
        toUser: '',
    },
};

export const initWizardPropsTranslation: IWizardPropsTranslation = {
    title: '',
    steps: {},
    error: {
        codes: {},
        defaultMessage: '',
    },
};
